var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowHardCarry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff07b",
    d: "M12.092.25l2.657.002.002 2.643-3.04 3.039L9.06 3.282zM1.25.25l2.66.002 8.863 8.864 1.061-1.06 1.06 1.06-1.855 1.856 2.121 2.122-1.06 1.06-2.122-2.122-1.857 1.857-1.06-1.06 1.06-1.062-8.868-8.869zm3.038 7.805l2.65 2.652-1.06 1.06 1.062 1.061-1.06 1.06-1.857-1.855L1.9 14.154l-1.06-1.06 2.122-2.123-1.857-1.855 1.061-1.06 1.06 1.059 1.06-1.06z"
  })));
}
export default __webpack_public_path__ + "static/svg/yellow-hard-carry.svg";
export { SvgYellowHardCarry as ReactComponent };